// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Error_backdrop__1Vpzt","modal":"Error_modal__Ie9i_","slide-down":"Error_slide-down__3Ja2Y"};